import React from "react";
import { Dialog } from "@mui/material";
import "./UploadResultDialog.scss";
import ButtonStyle from "../../../components/ButtonStyle/ButtonStyle";

interface Classroom {
  c_id: string;
  c_name: string;
}

interface UploadResult {
  filename: string;
  duplicates: number;
  classroomsFailed?: Classroom[];
  classrooms_failed: Classroom[];
  classrooms_updated: Classroom[];
  skipped_no_subject: number;
  classrooms_considered: Classroom[];
  classrooms_failed_count: number;
  classrooms_updated_count: number;
  classrooms_total_considered: number;
}

interface UploadDialogProps {
  open: boolean;
  onClose: () => void;
  results: UploadResult[];
  selectedPath: string;
}

const UploadResultsDialog: React.FC<UploadDialogProps> = ({
  open,
  onClose,
  results,
  selectedPath
}) => {
  console.log("[Upload Results] --- ", results);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      classes={{
        paper: "upload-bulk-popup",
      }}
    >
      <div className="upload-dialog">
        <div className="upload-dialog__header">
          <div className="heading">Upload Results</div>
          <span className="upload-dialog__close" onClick={onClose}>
            ✕
          </span>
        </div>

        <div className="upload-dialog__content">
          {results?.map((file, index) => {
            const failedClassrooms = file.classroomsFailed || file.classrooms_failed || [];
            return (
              <div key={index} className="upload-dialog__file-block">
                {/* <h3 className="upload-dialog__filename">{file.filename}</h3> */}

                {failedClassrooms.length > 0 && (
                  <div className="upload-dialog__section failed">
                    <div className="content">
                      <span className="error"> Error: </span> &nbsp;&nbsp;Duplicate Files
                      Detected, A file with this name already exists in the
                      following classrooms. Please ensure each file name is unique
                      before proceeding with the upload.
                    </div>
                    <ul>
                      {failedClassrooms.map((cls) => (
                        <li key={cls.c_id}>{cls.c_name}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* {file.classrooms_updated.length > 0 && (
                  <div className="upload-dialog__section success">
                    <p>
                      <strong>File uploaded in:</strong>
                    </p>
                    <ul>
                      {file.classrooms_updated.map((cls) => (
                        <li key={cls.c_id}>{cls.c_name}</li>
                      ))}
                    </ul>
                  </div>
                )} */}
              </div>
            );
          })}
        </div>
        <div className="okay-btn">
        <ButtonStyle onClick={onClose} text="Okay" width="100px"/>
        </div>
      </div>
    </Dialog>
  );
};

export default UploadResultsDialog;
